import { type AssistantToolCall } from 'components/framework/models';
import type Agent from '../../agents/Agent';
import type AssistedWhiteboard from '../../agents/WhiteboardAgent/AssistedWhiteboard';
import { type ToolHandler } from '../Tool';

export const makeWhiteboardToolHandler = (
  toolCallHandler?: (
    toolCall: AssistantToolCall,
    assistedWhiteboard: AssistedWhiteboard
  ) => void,
  toolCallDataProvider?: (
    toolCall: AssistantToolCall,
    assistedWhiteboard: AssistedWhiteboard
  ) => Object | false
): ToolHandler => {
  const handler: ToolHandler = {
    unavailable(agent: Agent): boolean {
      return !agent.contexts.assistedWhiteboard;
    },
  };

  if (toolCallHandler) {
    handler.processToolCall = (toolCall, agent) => {
      if (!agent.contexts.assistedWhiteboard) {
        console.warn('AssistedWhiteboard not found when processing tool call');
        return false;
      }

      return toolCallHandler(toolCall, agent.contexts.assistedWhiteboard);
    };
  }

  if (toolCallDataProvider) {
    handler.provideToolCallData = (toolCall, agent) => {
      if (!agent.contexts.assistedWhiteboard) {
        console.warn('AssistedWhiteboard not found when providing tool data');
        return false;
      }

      return toolCallDataProvider(toolCall, agent.contexts.assistedWhiteboard);
    };
  }

  return handler;
};
